module.exports = __webpack_public_path__ + "static/media/default_image.d2432d71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default_image.png
// module id = 761
// module chunks = 0